import React, { Component } from 'react'
import {
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
  FacebookShareCount,
} from 'react-share'
import config from '../../../config'
import './styles.sass'
import { sendGTagEvent } from '../../shared/helpers/gtagEventHelper'
const facebook_icon = require('../../assets/img/blog-f.svg')
const twitter_icon = require('../../assets/img/blog-t.svg')
const linkedin_icon = require('../../assets/img/blog-l.svg')

class Share extends Component {
  constructor (props) {
    super(props)
    this.sendEvent = this.sendEvent.bind(this)
  }

  sendEvent (provider) {
    sendGTagEvent(`shared-via-${provider}`, {
      event_category: 'general',
      event_label: this.props.slug,
    })
  }

  render () {
    const { title, slug, excerpt } = this.props
    const realPrefix = config.pathPrefix === '/' ? '' : config.pathPrefix
    const url = config.siteUrl + realPrefix + slug

    const filter = count => (count > 0 ? count : '')

    return (
      <div className='social-links blog-post'>
        <div className='share-this'>Share this post :</div>
        <FacebookShareButton url={url} quote={excerpt} beforeOnClick={() => this.sendEvent('fb')}>
          <div className='sm-image' style={{ backgroundImage: `url(${facebook_icon})` }} />
          <FacebookShareCount url={url}>
            {count => <div className='share-count'>{filter(count)}</div>}
          </FacebookShareCount>
        </FacebookShareButton>
        <TwitterShareButton url={url} title={title} beforeOnClick={() => this.sendEvent('twitter')}>
          <div className='sm-image' style={{ backgroundImage: `url(${twitter_icon})` }} />
        </TwitterShareButton>
        <LinkedinShareButton
          url={url}
          title={title}
          description={excerpt}
          beforeOnClick={() => this.sendEvent('linkedin')}
        >
          <div className='sm-image' style={{ backgroundImage: `url(${linkedin_icon})` }} />
        </LinkedinShareButton>
      </div>
    )
  }
}

export default Share
